import { defineMessages } from 'react-intl';

export const messages: {
	collapseSidebar: { defaultMessage: string; description: string; id: string };
	expandSidebar: { defaultMessage: string; description: string; id: string };
} = defineMessages({
	collapseSidebar: {
		defaultMessage: 'Collapse sidebar',
		description: 'Label for the button that collapses the sidebar navigation.',
		id: 'global-top-navigation.global-top-navigation.collapseSidebar',
	},
	expandSidebar: {
		defaultMessage: 'Expand sidebar',
		description: 'Label for the button that expands the sidebar navigation.',
		id: 'global-top-navigation.global-top-navigation.expandSidebar',
	},
});
